/**
 * Geolocation RTK Query API
 * Handles fetching and caching of live geolocation data
 */
import { api } from "../../api";
import { getSearchParams } from "../../../utils";

export const geolocationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Get current geolocations for all active users
     * Used for initial load and polling fallback
     */
    getGeolocations: builder.query({
      query: ({ userIds, freshnessMinutes = 30 } = {}) => {
        // Filter out undefined/null values before joining
        const validUserIds = userIds
          ? userIds.filter((id) => id != null && id !== "undefined" && id !== "null")
          : undefined;
        const params = getSearchParams({
          userIds: validUserIds?.length > 0 ? validUserIds.join(",") : undefined,
          freshnessMinutes,
        });
        return `geolocations?${params}`;
      },
      transformResponse: (response) => response.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ userId }) => ({
                type: "Geolocation",
                id: userId,
              })),
              { type: "Geolocation", id: "LIST" },
            ]
          : [{ type: "Geolocation", id: "LIST" }],
    }),

    /**
     * Get geolocation history for a specific user
     * Used for route replay
     */
    getGeolocationHistory: builder.query({
      query: ({ userId, startDate, endDate, shiftId, legId, limit = 1000 }) => {
        const params = getSearchParams({
          startDate,
          endDate,
          shiftId,
          legId,
          limit,
        });
        return `geolocations/history/${userId}?${params}`;
      },
      transformResponse: (response) => response.data,
      providesTags: (result, error, { userId }) => [
        { type: "GeolocationHistory", id: userId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetGeolocationsQuery, useGetGeolocationHistoryQuery } =
  geolocationApi;

